import { Control } from './control';
import { RequiredParent } from './required-parent';
import { CheckboxControl } from './checkbox-control';

export class Controller {
  constructor(
    private control: Control<any>,
    private readonly requirements: RequiredParent[]
  ) {}

  update(controlName: string, newValue: any): void {
    const parentValues = this.requirements.find(
      (requirement) => requirement.name === controlName
    ) as RequiredParent;
    const isVisible =
      parentValues.fields.length === 0 ||
      parentValues?.fields.indexOf(newValue) > -1;
    this.control.required =
      this.control instanceof CheckboxControl ? false : isVisible;
    this.control.setVisible(isVisible);
    this.control.refresh();
  }
}
